import { MuiOutlinedInput } from './text-field'

export const components = {
  MuiOutlinedInput,
}
